// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpeechControls__crossFade___UBkB0 {
    position: relative;
    display: block;
    width: 100%;
}

.SpeechControls__crossFade___UBkB0::before,
.SpeechControls__crossFade___UBkB0::after {
    position: absolute;
    top: 50%;
    width: calc(50% - 70px);
    height: 1px;
    content: "";
    pointer-events: none;
    transform: translateY(-50%);
}

.SpeechControls__crossFade___UBkB0::before {
    left: 0;
    background: linear-gradient(
        to right,
        transparent,
        rgba(173, 139, 62, 0.25)
    );
}

.SpeechControls__crossFade___UBkB0::after {
    right: 0;
    background: linear-gradient(
        to left,
        transparent,
        rgba(173, 139, 62, 0.25)
    );
}

.SpeechControls__crossFadeWithoutGradient___Xb00c::before,
.SpeechControls__crossFadeWithoutGradient___Xb00c::after {
    display: none;
}

.SpeechControls__controlButton___C18DO {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 29px;
    padding: 2px 12px;
    border: 1px solid rgba(143, 107, 55, 0.16);
    border-radius: 3px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.035);
    color: rgba(235, 230, 211, 0.88);
    font-family: "Montaga";
    font-size: 14px;
    font-style: normal;
    line-height: 20px;
    opacity: 0.82;
    text-shadow: none;
    white-space: nowrap;
    transition: background 120ms ease, border-color 120ms ease, color 120ms ease;
}

.SpeechControls__iconOnlyControlButton___BbKeg {
    width: 34px;
    padding-right: 6px;
    padding-left: 6px;
}

.SpeechControls__playbackModePicker___AnLEK {
    position: relative;
    display: inline-flex;
    align-items: stretch;
}

.SpeechControls__playbackModePicker___AnLEK > span {
    display: inline-flex;
}

.SpeechControls__playbackModePicker___AnLEK > span:first-child .SpeechControls__controlButton___C18DO {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.SpeechControls__playbackModePicker___AnLEK > span:nth-child(2) .SpeechControls__controlButton___C18DO {
    width: 22px;
    padding-right: 3px;
    padding-left: 3px;
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.SpeechControls__playbackModeMenu___p2R67 {
    position: absolute;
    bottom: calc(100% + 6px);
    left: 0;
    z-index: 5;
    display: flex;
    min-width: 132px;
    flex-direction: column;
    gap: 2px;
    padding: 5px;
    border: 1px solid rgba(173, 139, 62, 0.42);
    border-radius: 3px;
    background: linear-gradient(
        to bottom,
        rgba(48, 39, 24, 0.98),
        rgba(29, 25, 17, 0.98)
    );
    box-shadow: 0 5px 14px rgba(0, 0, 0, 0.55),
        inset 0 1px 0 rgba(225, 184, 101, 0.1);
    color: rgba(235, 230, 211, 0.92);
    font-family: "Montaga";
    text-align: left;
}

.SpeechControls__playbackModeOption___gkfYp {
    display: flex;
    align-items: center;
    gap: 7px;
    width: 100%;
    min-height: 28px;
    padding: 3px 7px;
    border: 1px solid transparent;
    border-radius: 2px;
    box-sizing: border-box;
    color: inherit;
    font-family: inherit;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    white-space: nowrap;
}

.SpeechControls__playbackModeOption___gkfYp:hover:not(:disabled) {
    border-color: rgba(173, 139, 62, 0.34);
    background: rgba(173, 139, 62, 0.18);
    color: rgba(245, 226, 164, 0.98);
}

.SpeechControls__playbackModeOption___gkfYp:disabled {
    cursor: not-allowed;
    opacity: 0.46;
}

.SpeechControls__playbackModeOptionIcon___Tcpyn {
    display: inline-flex;
    width: 12px;
    justify-content: center;
    color: rgba(210, 168, 75, 0.96);
    font-size: 11px;
}

.SpeechControls__pageAudioProgressIcon___wvwBt {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
}

.SpeechControls__pageAudioProgressRing___f11pH {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    overflow: visible;
}

.SpeechControls__pageAudioProgressRingTrack___Z_jOv,
.SpeechControls__pageAudioProgressRingIndicator___f1mlh {
    fill: none;
    stroke-width: 2;
}

.SpeechControls__pageAudioProgressRingTrack___Z_jOv {
    stroke: rgba(173, 139, 62, 0.26);
}

.SpeechControls__pageAudioProgressRingIndicator___f1mlh {
    stroke: rgba(245, 210, 108, 0.98);
    stroke-linecap: round;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
}

.SpeechControls__pageAudioProgressRingIndeterminate___FvpSJ {
    animation: SpeechControls__pageAudioProgressRingSpin___KGNao 1.1s linear infinite;
}

.SpeechControls__pageAudioProgressHourglass___qWfN8 {
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    line-height: 1;
}

.SpeechControls__controlButton___C18DO:hover {
    border-color: rgba(173, 139, 62, 0.34);
    background: rgba(173, 139, 62, 0.18);
    color: rgba(245, 226, 164, 0.98);
}

.SpeechControls__controlButton___C18DO:active {
    border-color: rgba(143, 107, 55, 0.28);
    background: rgba(0, 0, 0, 0.3);
}

.SpeechControls__controlButtonActive___r81Te {
    font-weight: bold;
    text-shadow: 0 0 10px gold;
}

.SpeechControls__controlButtonStarting___YjzqO {
    border-color: rgba(210, 168, 75, 0.62);
    background: rgba(173, 139, 62, 0.25);
    color: rgba(255, 231, 165, 1);
    box-shadow: 0 0 0 1px rgba(210, 168, 75, 0.2),
        0 0 10px rgba(210, 168, 75, 0.28);
    animation: SpeechControls__bookOfMindSpeechStartingPulse___MZngl 1.2s ease-in-out infinite;
}

.SpeechControls__controlButtonTarget___lZRZe {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 24px;
}

.SpeechControls__fadeIn___V_iTF,
.SpeechControls__fadeOut___Mppj5 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    z-index: 1;
}

.SpeechControls__fadeIn___V_iTF {
    animation: SpeechControls__bookOfMindSpeechControlsFadeIn___cYXGX 220ms ease-out both;
}

.SpeechControls__fadeOut___Mppj5 {
    position: absolute;
    inset: 0;
    pointer-events: none;
    animation: SpeechControls__bookOfMindSpeechControlsFadeOut___iEJxW 220ms ease-out both;
}

@keyframes SpeechControls__bookOfMindSpeechControlsFadeIn___cYXGX {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes SpeechControls__bookOfMindSpeechControlsFadeOut___iEJxW {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@keyframes SpeechControls__bookOfMindSpeechStartingPulse___MZngl {
    0%,
    100% {
        opacity: 0.82;
    }

    50% {
        opacity: 1;
    }
}

@keyframes SpeechControls__pageAudioProgressRingSpin___KGNao {
    from {
        transform: rotate(-90deg);
    }

    to {
        transform: rotate(270deg);
    }
}

@media (prefers-reduced-motion: reduce) {
    .SpeechControls__controlButtonStarting___YjzqO {
        animation: none;
    }

    .SpeechControls__pageAudioProgressRingIndeterminate___FvpSJ {
        animation: none;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"crossFade": `SpeechControls__crossFade___UBkB0`,
	"crossFadeWithoutGradient": `SpeechControls__crossFadeWithoutGradient___Xb00c`,
	"controlButton": `SpeechControls__controlButton___C18DO`,
	"iconOnlyControlButton": `SpeechControls__iconOnlyControlButton___BbKeg`,
	"playbackModePicker": `SpeechControls__playbackModePicker___AnLEK`,
	"playbackModeMenu": `SpeechControls__playbackModeMenu___p2R67`,
	"playbackModeOption": `SpeechControls__playbackModeOption___gkfYp`,
	"playbackModeOptionIcon": `SpeechControls__playbackModeOptionIcon___Tcpyn`,
	"pageAudioProgressIcon": `SpeechControls__pageAudioProgressIcon___wvwBt`,
	"pageAudioProgressRing": `SpeechControls__pageAudioProgressRing___f11pH`,
	"pageAudioProgressRingTrack": `SpeechControls__pageAudioProgressRingTrack___Z_jOv`,
	"pageAudioProgressRingIndicator": `SpeechControls__pageAudioProgressRingIndicator___f1mlh`,
	"pageAudioProgressRingIndeterminate": `SpeechControls__pageAudioProgressRingIndeterminate___FvpSJ`,
	"pageAudioProgressRingSpin": `SpeechControls__pageAudioProgressRingSpin___KGNao`,
	"pageAudioProgressHourglass": `SpeechControls__pageAudioProgressHourglass___qWfN8`,
	"controlButtonActive": `SpeechControls__controlButtonActive___r81Te`,
	"controlButtonStarting": `SpeechControls__controlButtonStarting___YjzqO`,
	"bookOfMindSpeechStartingPulse": `SpeechControls__bookOfMindSpeechStartingPulse___MZngl`,
	"controlButtonTarget": `SpeechControls__controlButtonTarget___lZRZe`,
	"fadeIn": `SpeechControls__fadeIn___V_iTF`,
	"fadeOut": `SpeechControls__fadeOut___Mppj5`,
	"bookOfMindSpeechControlsFadeIn": `SpeechControls__bookOfMindSpeechControlsFadeIn___cYXGX`,
	"bookOfMindSpeechControlsFadeOut": `SpeechControls__bookOfMindSpeechControlsFadeOut___iEJxW`
};
module.exports = ___CSS_LOADER_EXPORT___;
